import { render, staticRenderFns } from "./details.vue?vue&type=template&id=a31cae10&"
import script from "./details.ts?vue&type=script&lang=js&"
export * from "./details.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports